import { createTheme, ThemeProvider } from '@material-ui/core';
import { filterTheme } from 'theme.customize';

function ThemeFilter({ children }) {
  const theme = createTheme(filterTheme);
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}

export default ThemeFilter;
